'use strict';

var _regeneratorRuntime = require("/mnt/c/Users/lfege/Code/ipfs-nft-sandbox/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/mnt/c/Users/lfege/Code/ipfs-nft-sandbox/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _require = require('buffer'),
    Buffer = _require.Buffer;

var sha3 = require('js-sha3');

var mur = require('murmurhash3js-revisited');

var _require2 = require('./sha'),
    sha = _require2.factory;

var _require3 = require('./utils'),
    fromNumberTo32BitBuf = _require3.fromNumberTo32BitBuf; // Note that although this function doesn't do any asynchronous work, we mark
// the function as async because it must return a Promise to match the API
// for other functions that do perform asynchronous work (see sha.browser.js)
// eslint-disable-next-line


var hash = function hash(algorithm) {
  return (
    /*#__PURE__*/
    function () {
      var _ref = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(data) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.t0 = algorithm;
                _context.next = _context.t0 === 'sha3-224' ? 3 : _context.t0 === 'sha3-256' ? 4 : _context.t0 === 'sha3-384' ? 5 : _context.t0 === 'sha3-512' ? 6 : _context.t0 === 'shake-128' ? 7 : _context.t0 === 'shake-256' ? 8 : _context.t0 === 'keccak-224' ? 9 : _context.t0 === 'keccak-256' ? 10 : _context.t0 === 'keccak-384' ? 11 : _context.t0 === 'keccak-512' ? 12 : _context.t0 === 'murmur3-128' ? 13 : _context.t0 === 'murmur3-32' ? 14 : 15;
                break;

              case 3:
                return _context.abrupt("return", Buffer.from(sha3.sha3_224.arrayBuffer(data)));

              case 4:
                return _context.abrupt("return", Buffer.from(sha3.sha3_256.arrayBuffer(data)));

              case 5:
                return _context.abrupt("return", Buffer.from(sha3.sha3_384.arrayBuffer(data)));

              case 6:
                return _context.abrupt("return", Buffer.from(sha3.sha3_512.arrayBuffer(data)));

              case 7:
                return _context.abrupt("return", Buffer.from(sha3.shake128.create(128).update(data).arrayBuffer()));

              case 8:
                return _context.abrupt("return", Buffer.from(sha3.shake256.create(256).update(data).arrayBuffer()));

              case 9:
                return _context.abrupt("return", Buffer.from(sha3.keccak224.arrayBuffer(data)));

              case 10:
                return _context.abrupt("return", Buffer.from(sha3.keccak256.arrayBuffer(data)));

              case 11:
                return _context.abrupt("return", Buffer.from(sha3.keccak384.arrayBuffer(data)));

              case 12:
                return _context.abrupt("return", Buffer.from(sha3.keccak512.arrayBuffer(data)));

              case 13:
                return _context.abrupt("return", Buffer.from(mur.x64.hash128(data), 'hex'));

              case 14:
                return _context.abrupt("return", fromNumberTo32BitBuf(mur.x86.hash32(data)));

              case 15:
                throw new TypeError("".concat(algorithm, " is not a supported algorithm"));

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }()
  );
};

var identity = function identity(data) {
  return Buffer.from(data);
};

module.exports = {
  identity: identity,
  sha1: sha('sha1'),
  sha2256: sha('sha2-256'),
  sha2512: sha('sha2-512'),
  dblSha2256: sha('dbl-sha2-256'),
  sha3224: hash('sha3-224'),
  sha3256: hash('sha3-256'),
  sha3384: hash('sha3-384'),
  sha3512: hash('sha3-512'),
  shake128: hash('shake-128'),
  shake256: hash('shake-256'),
  keccak224: hash('keccak-224'),
  keccak256: hash('keccak-256'),
  keccak384: hash('keccak-384'),
  keccak512: hash('keccak-512'),
  murmur3128: hash('murmur3-128'),
  murmur332: hash('murmur3-32'),
  addBlake: require('./blake')
};